import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  id: "principles",
  class: "py-5 dark-section"
}
const _hoisted_2 = { class: "container text-center" }
const _hoisted_3 = { class: "row justify-content-center" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "card-body d-flex align-items-start" }
const _hoisted_7 = { class: "card-title" }
const _hoisted_8 = { class: "card-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "mb-5" }, "Unsere Prinzipien", -1)),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.principles, (principle) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["card h-card w-90 mb-4 slide-in-card", { 'slide-in-card-active': _ctx.cardsVisible }]),
            key: principle.id,
            onClick: ($event: any) => (!_ctx.isDesktop && _ctx.toggleExpand(principle.id))
          }, [
            (!_ctx.isDesktop)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "expand-btn",
                  onClick: _withModifiers(($event: any) => (_ctx.toggleExpand(principle.id)), ["stop"]),
                  "aria-label": "Expand principle description"
                }, [
                  _createElementVNode("i", {
                    class: _normalizeClass(_ctx.expandedIds.has(principle.id)
                ? 'fas fa-chevron-up'
                : 'fas fa-chevron-down')
                  }, null, 2)
                ], 8, _hoisted_5))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(principle.name), 1),
              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.expandedIds.has(principle.id) ? principle.description : principle.short), 1)
            ])
          ], 10, _hoisted_4))
        }), 128))
      ])
    ])
  ]))
}